<mat-chip *ngIf="share.isRestricted" size="xs">{{ 'shares.limited' | t }}</mat-chip>
<mat-chip *ngIf="share.userChangeOwner" size="xs">{{ 'shares.changeOwner' | t }}</mat-chip>
<mat-chip *ngIf="share.startDate" size="xs"
  >{{ 'shares.startLabel' | t }} {{ share.startDate | fsFormatDate : 'mediumDate' }}</mat-chip
>
<mat-chip *ngIf="share.endDate" size="xs"
  >{{ 'shares.endLabel' | t }} {{ share.endDate | fsFormatDate : 'mediumDate' }}</mat-chip
>
